import $axios from "@/common/http"  //导入封装的axios

export function selectArticleList(page:any=1,limit:any=5){
    return $axios.get("/article/selectArticleList",{params:{pageIndex:page,pageSize:limit}})
}

export function getAttachmentList(code:any){
    return $axios.get("/attachment/selectList",{params:code})
}

export function selectArticleInfo(articleId:number=1){
    return $axios.get("/article/selectArticleInfo?articleId="+articleId)
}